import { z } from "zod";

export const SyncFunctionCampaignsResponseBodySchema = z.object({
  deployed: z.boolean(),
});

export type SyncFunctionCampaignsResponseBodyType = z.infer<
  typeof SyncFunctionCampaignsResponseBodySchema
>;
